import {connect} from 'react-redux'
import * as favoritesActions from 'lib/api/favorites'
import {UserListItem} from 'common/ListItems'

const mapDispatchToProps = (dispatch) => {
  return {
    pin: (id) => dispatch(favoritesActions.pin('user', id)),
    unpin: (id) => dispatch(favoritesActions.unpin('user', id))
  }
}

const mapStateToProps = (state, ownProps) => {
  const favorites = state.favorites

  return {
    pinned: !!favorites.getIn(['favoritesByType', 'user', ownProps.user.get('id')])
  }
}

export const UserListItemContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserListItem)
